import { createContext, useContext, useReducer } from "react";
import { GlobalContext } from "../../../component/GlobalContext";

const UserContext = createContext(null);
const UserDispatchContext = createContext(null);

export const useUser = () => {
  return useContext(UserContext);
};

export const useDispatchUser = () => {
  return useContext(UserDispatchContext);
};

export const UserProvider = ({ children }) => {
  const { userInfo } = useContext(GlobalContext)

  const [user, dispatch] = useReducer(userReducer, {
    email: userInfo?.user?.email,
    nickname: userInfo?.user?.nickname,
    firstName: userInfo?.user?.first_name,
    lastName: userInfo?.user?.last_name,
    phone: "",
  });

  return (
    <UserContext.Provider value={user}>
      <UserDispatchContext.Provider value={dispatch}>{children}</UserDispatchContext.Provider>
    </UserContext.Provider>
  );
};

const userReducer = (user, action) => {
  switch (action.type) {
    case "USER_UPDATED":
      return { ...user, ...action.payload };
    case "NICKNAME_CHANGED":
      return { ...user, nickname: action.nickname };
    case "EMAIL_CHANGED":
      return { ...user, email: action.email };
    case "USER_DELETED":
      return { ...user, deleted: true };
  }
};
